import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import CircularProgress from 'material-ui/CircularProgress';
import { DataGrid } from '@material-ui/data-grid';
import moment from 'moment';
import { formatIdentifierForApi } from '../../../utils/incidentHelper';
import originFields from '../../../defaults/PointOfOriginFields.json'
import theme from '../../../muiTheme';
import { getMapExtent } from '../../esri/mapHub';
import XLSX from 'xlsx';

class PerimeterAttributes extends Component
{

  constructor (props)
  {
    super(props);
    this.state =
    {
      isQuerying: false,
      perimeterMapMethod: '',
      perimeterFeatureAccess: '',
      perimeterFeatureStatus: '',
      incidentsMatchingPerimeterCriteria: []
    };
  }

  queryForPerimeters = () =>
  {
    this.setState({
      isQuerying: true
    });

  getMapExtent().then(mapExtent => {
    window.api.getIdsForPerimeterFilters(this.state.perimeterMapMethod, this.state.perimeterFeatureStatus, this.state.perimeterFeatureAccess, mapExtent, 0, []).then(
      results =>
      {
        const filteredIrwinIds = results.filter(result => result.attributes.IRWINID && result.attributes.IRWINID.length > 5).map(filteredResult =>
          {
          return formatIdentifierForApi(filteredResult.attributes.IRWINID);
        });


        const matchingPerimeterCriteria = this.props.incidentList.visibleIncidents.filter(incident => filteredIrwinIds.includes(formatIdentifierForApi(incident.attributes[originFields.irwinId])));
        this.setState({
          isQuerying: false,
          incidentsMatchingPerimeterCriteria: matchingPerimeterCriteria
        });
      });
    });
 }

  formatCsvData = () =>
  {
    let firstRow = ['IrwinID', 'Incident Name', 'Fire Discovery Date', 'Incident Size'];
    let dataRows = [firstRow];

    for (let i = 0; i < this.state.incidentsMatchingPerimeterCriteria.length; i++)
    {
      let newRow = [formatIdentifierForApi(this.state.incidentsMatchingPerimeterCriteria[i].attributes[originFields.irwinId]), this.state.incidentsMatchingPerimeterCriteria[i].attributes[originFields.name], moment(new Date(this.state.incidentsMatchingPerimeterCriteria[i].attributes[originFields.discoveryDate])).format("MM/DD/YYYY h:mm A"), this.state.incidentsMatchingPerimeterCriteria[i].attributes[originFields.incidentSize]]
      dataRows.push(newRow);
    }

    return dataRows;
  }

  downloadCsv = () =>
  {

    const workbook = XLSX.utils.book_new();
    let csvData = this.formatCsvData();
    let reportSheet = XLSX.utils.aoa_to_sheet(csvData);

    XLSX.utils.book_append_sheet(workbook, reportSheet, "PerimeterAttributes");
    XLSX.writeFile(workbook, "PerimeterAttributes.xlsx");
  }

  render()
  {
    if (!this.props.visible)
    {
      return null;
    }

    const columns = [
      { field: 'irwinId', headerName: 'Irwin ID', width: 320},
      { field: 'incidentName', headerName: 'Incident Name', width: 180 },
      { field: 'fireDiscoveryDate', headerName: 'Fire Discovery Date', width: 180 },
      { field: 'incidentSize', headerName: 'Incident Size', width: 90 }
    ];

    const rows = this.state.incidentsMatchingPerimeterCriteria.map(incident =>
            {
              return {
                id: incident.attributes[originFields.irwinId],
                irwinId: formatIdentifierForApi(incident.attributes[originFields.irwinId]),
                incidentName: incident.attributes[originFields.name],
                fireDiscoveryDate:  moment(new Date(incident.attributes[originFields.discoveryDate])).format("MM/DD/YYYY h:mm A"),
                incidentSize: incident.attributes[originFields.incidentSize]
              }
          });

    const loadingIcon = (this.state.isQuerying) ? (
        <div>Querying for Perimeters ... <CircularProgress size={24} thickness={2} color={theme.palette.primary1Color} /></div>
    ) : "";

    return (this.props.visible) ? (
        <Paper>
        <Grid container spacing={2}>
         <Grid item xs={12}>
             <Grid container justify="center" spacing={3}>
                   <Grid key={0} item>
                   <b>Map Method</b> <Select
                   native
                   value={this.state.perimeterMapMethod}
                   onChange={(event) =>
                     {
                       this.setState({
                        perimeterMapMethod: event.target.value
                      });
                      this.queryForPerimeters();
                     }}>
                      <option value={null}></option>
                      <option value='GPS-Driven'>GPS-Driven</option>
                      <option value='GPS-Flight'>GPS-Flight</option>
                      <option value='GPS-Walked'>GPS-Walked</option>
                      <option value='GPS-Walked/Driven'>GPS-Walked/Driven</option>
                      <option value='GPS-Unknown Travel Method'>GPS-Unknown Travel Method</option>
                      <option value='Hand Sketch'>Hand Sketch</option>
                      <option value='Digitized-Image'>Digitized-Image</option>
                      <option value='Digitized-Topo'>Digitized-Topo</option>
                      <option value='Digitized-Other'>Digitized-Other</option>
                      <option value='Image Interpretation'>Image Interpretation</option>
                      <option value='Infrared Image'>Infrared Image</option>
                      <option value='Modeled'>Modeled</option>
                      <option value='Mixed Methods'>Mixed Methods</option>
                      <option value='Remote Sensing Derived'>Remote Sensing Derived</option>
                      <option value='Survey/GCDB/Cadastral'>Survey/GCDB/Cadastral</option>
                      <option value='Vector'>Vector</option>
                      <option value='Phone/Tablet'>Phone/Tablet</option>
                      <option value='Other'>Other</option>
                      <option value='Auto-generated'>Auto-generated</option>
                     </Select>
                   </Grid>
                   <Grid key={1} item>
                   <b>Feature Status</b> <Select
                   native
                   value={this.state.perimeterFeatureStatus}
                   onChange={(event) =>
                     {
                       this.setState({
                        perimeterFeatureStatus: event.target.value
                      });
                      this.queryForPerimeters();
                     }}>
                      <option value={null}></option>
                      <option value='Approved'>Approved</option>
                      <option value='In Review'>In Review</option>
                      <option value='Proposed'>Proposed</option>
                      <option value='Archive'>Archive</option>
                     </Select>
                   </Grid>
                   <Grid key={2} item>
                   <b>Feature Access</b><Select
                   native
                   value={this.state.perimeterFeatureAccess}
                   onChange={(event) =>
                     {
                       this.setState({
                        perimeterFeatureAccess: event.target.value
                      });
                      this.queryForPerimeters();
                     }}>
                      <option value={null}></option>
                      <option value='Public'>Public</option>
                      <option value='Cooperators'>Cooperators</option>
                      <option value='Incident'>Incident</option>
                      <option value='Restricted'>Restricted</option>
                      <option value='Unknown'>Unknown</option>
                     </Select>
                   </Grid>
             </Grid>
         </Grid>
        </Grid>
        {loadingIcon}
        <div style={{ minHeight: 500, width: 900 }}>
        <DataGrid rows={rows} columns={columns} pageSize={15} checkboxSelection />
        </div>
    </Paper>
    ) : "";
  }
}

export default PerimeterAttributes
